import { FC, Dispatch, SetStateAction } from 'react'
import { SelectChangeEvent } from '@mui/material'
import { Dayjs } from 'dayjs'
import { Wrapper } from './labelFilters.styles'
import UncontrolledSelect, { SelectOption } from 'ui/components/form-components/UncontrolledSelect'
import DateRangePicker from 'ui/components/date-range-picker'

const labelOptions = [
  {
    label: 'SLA Changed',
    value: 'sla_changed'
  },
  {
    label: 'CPI Activated',
    value: 'cpi_activated'
  },
  {
    label: 'Instance Added',
    value: 'instance_added'
  },
  {
    label: 'Instance Removed',
    value: 'instance_removed'
  },
  {
    label: 'Custom Label',
    value: 'custom_label'
  }
] as SelectOption[]

const allOption: SelectOption = {
  label: `All (${labelOptions.length})`,
  value: 'all'
}

const options = [allOption, ...labelOptions]

interface Props {
  selectedLabelTypes: string[]
  setSelectedLabelTypes: Dispatch<SetStateAction<string[]>>
  selectedDateRange: [Dayjs | null, Dayjs | null]
  setSelectedDateRange: (newRange: [Dayjs | null, Dayjs | null]) => void
}

const LabelFilters: FC<Props> = ({
  selectedLabelTypes,
  setSelectedLabelTypes,
  selectedDateRange,
  setSelectedDateRange
}) => {
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string[]

    if (value.includes('all')) {
      if (selectedLabelTypes.length === labelOptions.length) {
        setSelectedLabelTypes([])
      } else {
        setSelectedLabelTypes(labelOptions.map((opt) => opt.value))
      }
    } else {
      setSelectedLabelTypes(value)
    }
  }

  const handleDateRangeChange = (newRange: [Dayjs | null, Dayjs | null]) => {
    setSelectedDateRange(newRange)
  }

  return (
    <Wrapper className="label-filters-wrapper">
      <UncontrolledSelect
        value={selectedLabelTypes}
        onChange={handleChange}
        options={options}
        placeholder={`Select All (${options.length - 1})`}
        label="Label Type"
        multiple
        withCheckbox
        dropdownHeight="264px"
      />
      <DateRangePicker value={selectedDateRange} onChange={handleDateRangeChange} label="Time Period" disableFuture />
    </Wrapper>
  )
}

export default LabelFilters
